// @flow
import React, { useState, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { QuestionInterface } from 'types/QuestionInterface'
import Scrollchor from 'react-scrollchor'

import { browserCheck } from '@ta-interaktiv/browsercheck'
import { hot } from 'react-hot-loader/root'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

import { Footer } from '@ta-interaktiv/react-footer'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { MobileVersion } from '../mobileVersion'
import { DesktopVersion } from '../desktopVersion'
import { MDX } from 'contentbricks'

import { categoryData } from './data'
import GetSheetDone from 'get-sheet-done'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'

const csvQuestionData = require('./fragenzumschlaf - Sheet1.csv')
const LOAD_FROM_CSV = true

// Global variable for the mantel links provided in the .mdx files
window.mandant = parseHostname().publicationName

// TODO Set the correct article ID here
const ARTICLE_ID = '18909006'
const GOOGLE_SHEET_ID = '15_UtWciecj2i4IEMv050MurX85dtGAZoHVYLTqjYLDc'
const RELATED_SHEET_ID = '1MwIYFzGQ5kJOrbW6HzjWs2CZWoUH1WIo5RvF45t2XJo'
const RELATED_SHEET_ROW = 'fragen'
const IMPRESSUM = require('../_text/_impressum.yml')
const formatSources = (yml: [[]]) => {
  var ret = IMPRESSUM.map(n => {
    if (n.length == 2) return '<a href="' + n[1] + '">' + n[0] + '</a>'
    return n[0]
  })
  return ret.join(', ')
}
function AppComponent() {
  const [datas, setData] = useState<QuestionInterface[]>([])
  const [questionCount, setQuestionCount] = useState<number | undefined>(
    undefined
  )
  const [related, setRelated] = useState<string[]>([])
  useEffect(() => {
    if (LOAD_FROM_CSV) {
      setData(csvQuestionData)
      setQuestionCount(
        csvQuestionData.filter(f => {
          if (f.category !== 'a') return f
        }).length
      )
    } else {
      GetSheetDone.raw(GOOGLE_SHEET_ID).then(
        (sheet: { data: string[][]; title: string; updated: string }) => {
          var keys = sheet.data[0]
          var newData: QuestionInterface[] = []
          sheet.data.shift()

          sheet.data.forEach(element => {
            var newEl: QuestionInterface = {}
            keys.forEach((key: string, i: number) => {
              newEl[key] = element[i]
            })
            newData.push(newEl)
          })
          // console.log('GOOGLE SHEET READY')
          // console.log(newData)

          setData(newData)
          setQuestionCount(
            newData.filter(f => {
              if (f.category !== 'a') return f
            }).length
          )
        }
      )
    }
    GetSheetDone.raw(RELATED_SHEET_ID).then((sheet: any) => {
      let articles = sheet.data.map(r => {
        if (r[0] === RELATED_SHEET_ROW) return r
      })[0]
      articles.shift()
      setRelated(articles)
    })
  }, [])
  return (
    <div className='index'>
      {/* TODO Replace the following segment with your project cover */}
      <div id='mainContainer'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />
        {(browserCheck.isDesktop || browserCheck.isTablet) && (
          <header className=' headerContainerDesktop'>
            <div className='titelContainer'>
              <h1>
                {questionCount && <div className='qNumber'>77</div>}
                <br />
                FRAGEN ZUM
                <br />
                <strong>SCHLAF</strong>
              </h1>
            </div>
            <div>
              <img src={require('../../images/header_buch.png')} />
            </div>
          </header>
        )}
        {!browserCheck.isDesktop && !browserCheck.isTablet && (
          <header className='headerContainerMobile'>
            <div className='image'>
              <img src={require('../../images/header_buch.png')} />
            </div>
            <div className='titelContainer'>
              <h1>
                {questionCount && (
                  <div className='qNumber'>{questionCount}</div>
                )}
                <br />
                FRAGEN ZUM
                <br />
                <strong>SCHLAF</strong>
              </h1>
            </div>
          </header>
        )}
        <div className='ui container introText' id='contentGrid'>
          <div className='ui fitted text container '>
            <MDX file={require('../_text/intro.mdx')} />
          </div>
          <a id='navi' />

          {!browserCheck.isMobile && (
            <div className='ui text container nav' id='navi'>
              <div className='naviTip'>Direkt zu den Bereichen:</div>
              <div>
                {categoryData.map((c, i) => {
                  return (
                    <Scrollchor key={i} to={'#' + c.cat}>
                      <div
                        className='navEntry'
                        onClick={() => {
                          let dataLayer = window.dataLayer || []
                          dataLayer.push({
                            event: 'Interactions',
                            event_action: 'click',
                            event_label: 'desktopMenuCat:' + c.name
                          })
                        }}
                      >
                        {c.name}
                        <i className='arrow alternate down  icon' />
                      </div>
                    </Scrollchor>
                  )
                })}
              </div>
            </div>
          )}
        </div>
        {(browserCheck.isDesktop || browserCheck.isTablet) && (
          <DesktopVersion
            articleID={ARTICLE_ID}
            categories={categoryData}
            questions={datas}
          />
        )}
        {!browserCheck.isDesktop && !browserCheck.isTablet && (
          <MobileVersion
            articleID={ARTICLE_ID}
            categories={categoryData}
            questions={datas}
          />
        )}

        {/* TODO Add your credits in this component */}
      </div>
      <Footer
        questions={[
          'Wie informativ ist dieses Kompendium?',
          'Wie sehr schätzen Sie das lange Format?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept und Programmierung',
            'Sebastian Broschinski und Marc Brupbacher'
          ],
          ['Illustrationen', 'Sebastian Broschinski'],
          [
            'Texte',
            'Katharina Graf, Silvia Aeschbach, Marc Brupbacher, Mathias Lutz, Niklaus Walter'
          ],
          [
            'Quellen',
            '«Tages-Anzeiger», «Sonntagszeitung», «Süddeutsche Zeitung», «Science», «Sleep», «Dreaming», «Journal of Clinical Sleep Medicine», «British Medical Journal», National Health Foundation – NHFCA, Welt.de, srf.ch, navigator-medizin.de, www.medizin-transparent.at, bbc.com, Bundesamt für Umwelt, WHO, Duke University, University of East London, University of California, University of Michigan, University of Chicago, University of Pittsburgh, Virginia Tech University, University of Maryland, Universität Stockholm, Universität Zürich, Universität Basel, Universität Bern, Universitäre Psychiatrische Kliniken Basel, Zentrum für Angst- und Depressionsbehandlung Zürich, Universitätsklinik Zürich, Technische Universität München, Gottlieb-Duttweiler-Institut, «Why We Dream», «Warum wir schlafen», «Das grosse Buch vom Schlaf», «Typical Dreams Questionnaire», «Women’s Health Initiative», McKinsey, «Guinnessbuch der Rekorde», National Center for Biotechnology Information.'
          ]
        ]}
      >
        {/* {' '}
        <div className='ui container' style={{ marginBottom: '50px' }}>
          <ArticleTeasers
            numberOfCards='three'
            sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
            articleIds={related}
          />
        </div> */}
      </Footer>
    </div>
  )
}

export default hot(AppComponent)
